import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useSearchAnalyticsFields() {
  const reduxQuery = useSelector((state) => state.search.selectedQuery);
  const currentQuery = useSelector((state) => state.search.currentQuery);
  const templates = useSelector((state) => state.forms.templates);
  const boardCardTemplates = useSelector((state) => state.boards.cardTemplates);

  const selectedQuery = useMemo(() => currentQuery ?? reduxQuery, [currentQuery, reduxQuery]);

  return useMemo(() => {
    const analyticsFieldIds = selectedQuery?.query?.formulas
      ?.filter((f) => f.analytics)
      .map((f) => f.field) ?? [];

    let templateSections = [];
    if (selectedQuery?.type === 'boards') {
      const cardTypeId = selectedQuery?.query?.cardTypeId;
      templateSections = boardCardTemplates?.[cardTypeId]?.fields ?? [];
    } else if (selectedQuery?.type === 'forms') {
      const templateId = selectedQuery?.query?.templateId;
      templateSections = templates?.[templateId]?.formData?.sections ?? [];
    }

    const fieldById = {};
    templateSections.forEach((section) => {
      (section.fields ?? []).forEach((field) => {
        fieldById[field.id] = field;
      });
    });

    return analyticsFieldIds.map((fieldId) => ({
      fieldId,
      name: fieldById[fieldId]?.configProps?.title,
    }));
  }, [selectedQuery, boardCardTemplates, templates]);
}
